<template>
    <data v-if="user">
        <div class="flex justify-between items-center pb-4">
        <div class="flex flex-wrap">
            <div class="w-56 pr-5 text-xs text-black">
                <p class='py-1'>Select Status</p>
                <v-select v-model="selectedLicenseStatus" :items="licenseStatusList" density="compact"
                    variant="outlined" placeholder="Select License Status" rounded="0"
                    style="padding-top: 0px;padding-bottom: 0px;" class="bg-white text-black">
                </v-select>
            </div>
            <div class="w-56 pr-5 text-xs text-black">
                <p class='py-1'>Select View Method</p>
                <v-select v-model="selectedView" :items="viewList" density="compact"
                    variant="outlined" placeholder="Select License Status" rounded="0"
                    style="padding-top: 0px;padding-bottom: 0px;" class="bg-white text-black">
                </v-select>
            </div>
            <div class="w-56 pr-5 text-xs text-black">
                <p class='py-1'>Search proxies</p>
                <v-text-field v-model="searchProxy" clearable autocomplete="off" aria-label="Search proxies" density="compact"
                    variant="outlined" placeholder="IP, port, or full proxy" rounded="0"
                    style="padding-top: 0px;padding-bottom: 0px;" class="bg-white text-black">
                </v-text-field>
            </div>
            <div @click="toggleSelection()" class="ml-auto align-self-center flex flex-row mt-[20px] cursor-pointer">
                <input :checked="expiringIn" class="form-check-input shadow-none cursor-pointer mr-[5px]" type="checkbox" />
                <span>Expiring in 24 hours</span>
            </div>
        </div>
      </div>
        <div v-if="loading === true" class=" flex items-center justify-center absolute w-full h-1/3 custom-style " >
            <img src="../../../assets/loading.gif" class="w-[50px]"/>
        </div>
   
      <div v-if="selectedView === 'Table'" class="px-4 py-4 bg-white">
          
          <v-data-table :headers="headers" :mobile="false" items-per-page="-1"
              :items="filteredProxies"
              item-key="uuid" class=" bg-gray border text-black min-h-[500px]" style="font-size: 13px;" :style="`height: ${computedHeight}px;`">

              <template v-slot:[`item.no`]="{ index }">
                  {{ index + 1 }}
              </template>
              <template v-slot:[`item.note`]="{item}">
                <div class="flex flex-row text-sm ">
                    <div v-if="item.note" class="flex justify-between items-center bg-white px-3 w-[150px] py-1 text-black">
                        <pre class="text-green-600 font-bold w-full">{{item.note}}</pre>
                    </div>
                    <div class="flex flex-row items-center">
                        <v-icon v-if="item.note" icon="mdi-square-edit-outline"  class="cursor-pointer my-[1px] mx-4"
                            data-bs-toggle="modal" color="light-green mx-1"
                            data-bs-target="#noteModal"
                            @click="proxyAction(item, 'UPDATENOTE')"
                        ></v-icon>
                        <v-icon v-else icon="mdi-plus-thick"  class="cursor-pointer my-[1px] mx-4"
                            data-bs-toggle="modal" color="light-green mx-1"
                            data-bs-target="#noteModal"
                            @click="proxyAction(item, 'ADDNOTE')"
                        ></v-icon>
                    </div>
                  </div>
              </template>
              <template v-slot:[`item.coupon_code`]="{item}">
                <div class="flex flex-row text-sm ">
                    <div class="pl-4 text-green-600">{{item?.coupon_code}}</div>
                    <v-icon v-if="item?.coupon_code" icon="mdi-square-edit-outline"  class="cursor-pointer my-[1px] mx-4"
                            data-bs-toggle="modal" color="light-green mx-1"
                            data-bs-target="#couponModal"
                            @click="proxyAction(item, 'EDITCOUPON')"
                    ></v-icon>
                    <v-icon v-else icon="mdi-plus-thick"  class="cursor-pointer my-[1px] mx-4"
                        data-bs-toggle="modal" color="light-green mx-1"
                        data-bs-target="#couponModal"
                        @click="proxyAction(item, 'EDITCOUPON')"
                    ></v-icon>
                </div>
              </template>
              <template v-slot:[`item.status`]="{ item }">
                  <div class="space-y-1 py-1 font-semibold ">
                      <div class="flex justify-between items-center bg-white px-3 py-1 text-black">
                          Server Online <v-icon icon="mdi-circle" size="15"
                              :color="item.modem_conn_status ? 'green' : 'red'" class="mr-2"></v-icon>
                      </div>
                      <div class="flex justify-between items-center bg-white px-3 py-1 text-black">
                          Proxy Online <v-icon icon="mdi-circle" size="15"
                              :color="(item.proxy_status === 'CONNECTED' || true)? 'green' : 'red'" class="mr-2"></v-icon>
                      </div>
                  </div>
              </template>
              <template v-slot:[`item.expired_date`]="{ item }">
                  <div v-if="calculateRemainingTime(item.expired_date).isOne" class="text-red-600 font-bold">Remaining: {{ calculateRemainingTime(item.expired_date).time }}</div>
                  <div v-else class="text-green-600 font-bold">Remaining: {{ calculateRemainingTime(item.expired_date).time }}</div>
                  <div>Start: {{ formatDate(new Date(item.start_date)) }}</div>
                  <div>Expire: {{ formatDate(new Date(item.expired_date)) }}</div>
              </template>
              <template v-slot:[`item.proxy_ports`]="{ item }">
                  <div>
                      Proxy: {{ item.modem_name }}
                  </div>
                  <div class="flex items-center justify-between">
                      {{ item.m_type === 'PROPROXYUI' ? 'HTTP / SOCKS5' : 'HTTP' }}: {{ `${item.host_domain}:${item.http_port}` }}
                      <div>

                          <v-btn density="compact" variant="text" icon="mdi-pencil-box-multiple-outline"
                              @click="copyText(`${item.host_domain}:${item.http_port}${item.authentication_user === '' ? '' : ':' + item.authentication_user}`)"
                              color="light-green">
                              <v-icon icon="mdi-pencil-box-multiple-outline" size="17"></v-icon>
                          </v-btn>
                      </div>
                  </div>
                  <div v-if="item.m_type === 'PROPROXYUI' && item.socks_udp" class="pp-udp-note"><span class="udp-pill"><v-icon icon="mdi-check" size="11"></v-icon>UDP</span>SOCKS5 needed for UDP</div>
                  <div v-if="item.m_type !== 'PROPROXYUI'" class="flex items-center justify-between">
                      <span>SocksV5: {{ `${item.host_domain}:${item.socket_port}` }}</span>
                      <div>

                          <v-btn density="compact" variant="text" icon="mdi-pencil-box-multiple-outline"
                              @click="copyText(`${item.host_domain}:${item.socket_port}${item.authentication_user === '' ? '' : ':' + item.authentication_user}`)"
                              color="light-green">
                              <v-icon icon="mdi-pencil-box-multiple-outline" size="17"></v-icon>
                          </v-btn>
                      </div>
                  </div>
              </template>
              <template v-slot:[`item.ip_status`]="{ item }">
                  <div class="flex flex-col">
                      <div :class="ipStatus[item.uuid] ? 'text-light-green' : 'text-red'"
                          class="font-bold flex justify-center items-center">
                          <div>{{ displayProxyIp(item) }}</div>
                          <v-btn density="compact" variant="text" icon="mdi-refresh" color="light-green"
                              @click="refreshIp(item.uuid)"></v-btn>
                      </div>
                      <v-btn :disabled="!ipStatus[item.uuid]" class="font-bold bg-dark text-light" variant="outliend"
                          style="outline:none; font-size: 12px;" density="compact" @click="changeIp(item.uuid)">
                          Change IP
                      </v-btn>
                      <div v-if="item.m_type === 'PROXYSMART'" :style="checkDownloadLimit(item, item.dl_bytes) ? 'color: red' : ''">
                      {{ item.dl_bytes && item.dl_bytes !== "NaN" ? item.dl_bytes : '0MB'}} 
                      </div>
                      <div v-else-if="item.m_type === 'X_PROXY'">
                          <div :style="checkDownloadLimit(item, item.dl_bytes) ? 'color: red' : ''">
                              HTTP: 
                              {{ item.dl_bytes }} MB
                          </div>
                          <div :style="checkDownloadLimit(item, (item.counter_dl_used_bytes / (1024 * 1024))) ? 'color: red' : ''">
                              SOCKS5:  
                              {{ (item.counter_dl_used_bytes / (1024 * 1024)).toFixed(2) }} MB
                          </div>
                      </div>
                      <div v-else-if="item.m_type === 'IPROXY'">
                        {{ item.dl_bytes && item.dl_bytes !== "NaN" ? (parseFloat(item.dl_bytes).toFixed(2) + ' MB') : '0MB'}} 
                      </div>
                      <div v-else-if="item.m_type === 'PROPROXYUI'" :style="ppOver(item) ? 'color: red' : ''">
                        {{ ppUsage(item) }}
                      </div>
                  </div>
              </template>
              <template v-slot:[`item.buttonBar`]="{ item }">
                  <v-menu offset-y location="bottom">
                      <template v-slot:activator="{ props, on, isActive }">
                          <v-btn v-bind="props" v-on="{ ...on }" density="compact"
                              :style="isActive ? 'border-bottom-left-radius: 0px;border-bottom-right-radius: 0px;' : ''"
                              style="outline: none; font-size: 10px; " class="w-32 z-10 bg-dark text-light">
                              Actions
                              <v-icon icon="mdi-chevron-down" size="14"></v-icon>
                          </v-btn>
                      </template>
                      <v-list class="w-32 flex-1 flex flex-col px-0 py-0  z-0"
                          style="border-top-left-radius: 0px;border-top-right-radius: 0px">

                          <template v-for="(button, index) in getActionButtons(item)" :key="index">
                              <!-- Check if button is "abc" -->

                              <v-btn @click="proxyAction(item, button)" rounded="0"
                                  class="bg-dark text-light text-center "
                                  style="font-size: 10px; width: 128px; outline: none; border-bottom: 1px solid #345;"
                                  type="button"
                                  :data-bs-toggle="(button === 'AUTO ROTATION' || button === 'AUTHENTICATION' || button === 'EXTEND' || button === 'OS Spoofing' || button === 'MOVE LOCATION' || button === 'VPN' || button === 'IP HISTORY') && 'modal'"
                                  :data-bs-target="button === 'AUTO ROTATION' ? '#autoRotationDialog' :
      button === 'AUTHENTICATION' ? '#authenticationModal' :
          button === 'EXTEND' ? '#extendLicenseModal' : button === 'OS Spoofing' ? '#osSpoofingModal' :
            button === 'MOVE LOCATION' ? '#moveLocationModal' : button === 'VPN' ? '#vpnModal' : button === 'IP HISTORY' ? '#ipChangeHistoryModal' :
              ''">
                                  {{ buttonLabel(button, item) }}
                              </v-btn>
                              
                          </template>
                      </v-list>
                  </v-menu>
              </template>
              <template v-slot:[`item.auto_extend`]="{ item }" >
                  <div class="flex flex-col">
                      <div class="flex justify-center my-1">
                          <v-switch density="dense" color="light-green" v-model="item.auto_extend" label-placement="left"
                              label="" @click="updateAutoExtend(item)"></v-switch>
                      </div>
                      {{ item.auto_rotation_time <= 0 ? 'Not defined' : item.auto_rotation_time + ' min' }}
                  </div>
              </template>
              <template v-slot:[`item.auth`]="{ item }">
                  <div class="flex items-center ">
                      <div class="w-32 mx-auto" @click="alert">
                          <div class="text-start flex items-center">
                              <v-icon icon="mdi-account-key" color="light-green mx-1"></v-icon>
                              {{ (item.authentication_user === '' || item.authentication_user === null) ? `- - - - - /
                              - -
                              - - - ` : item.authentication_user }}
                          </div>
                          <div class="text-start flex items-center">
                              <v-icon icon="mdi-ip" color="light-green mx-1"></v-icon>
                              {{ (item.authorization_ips === "" || item.authorization_ips === null) ? `- - - - - / - -
                              - -
                              - ` : item?.authorization_ips?.replace(/,/g, ', ') }}
                          </div>
                          <div v-if="item.m_type === 'PROPROXYUI' && item.os_spoofing && ppOsActive(item)" class="text-start"><span class="os-chip">{{ ppOsChip(item) }}</span></div>
                      </div>
                      <div class="flex flex-col items-end">
                          <v-icon icon="mdi-application-edit"  class="cursor-pointer my-[1px]"
                          data-bs-toggle="modal" color="light-green mx-1"
                          data-bs-target="#authenticationModal"
                          @click="proxyAction(item, 'AUTHENTICATION')"
                          ></v-icon>
                          <div v-if="item.m_type === 'PROXYSMART'" class="w-full flex flex-col items-center justify-center my-[1px]">
                              <span class=" text-[10px] text-green-500">OpenVPN:</span>
                              <img src="../../../assets/openVPN.png" :alt="proxy" @click="downloadFile(`${item.domain}/get_vpn_profile/${item.port_id}.ovpn`)" class=" cursor-pointer"/>
                          </div>
                          <div v-else-if="item.m_type === 'IPROXY'" class="w-full flex flex-col items-center justify-center my-[1px]">
                              <span class=" text-[10px] text-green-500">OpenVPN:</span>
                              <img src="../../../assets/openVPN.png" :alt="proxy" @click="downloadIproxyOpenVpn(item)" class=" cursor-pointer"/>
                          </div>
                          <!-- ProProxyUI: WireGuard / OpenVPN files, their QR codes and whether they are connected -->
                          <div v-else-if="item.m_type === 'PROPROXYUI' && item.status === 'ACTIVE' && (item.vpn_wg || item.vpn_ovpn)" class="vpn-stack">
                              <div v-if="item.vpn_wg" class="vpn-item" title="Download the WireGuard file">
                                  <img :src="wireGuardLogo" alt="WireGuard" class="vpn-logo vpn-logo--wg cursor-pointer" @click="downloadVpn(item, 'wg')"/>
                                  <div class="vpn-item__text">
                                      <span class="vpn-item__name">WireGuard <button type="button" class="vpn-dl" @click="downloadVpn(item, 'wg')"><v-icon icon="mdi-download" size="11"></v-icon>Download</button><button type="button" class="vpn-dl" @click="showVpnQr(item, 'wg')"><v-icon icon="mdi-qrcode" size="11"></v-icon>QR</button></span>
                                      <span v-if="item.vpn" class="vpn-state" :class="{ 'is-on': item.vpn.wg_connected }"><i></i>{{ item.vpn.wg_connected ? 'Connected' : 'Not connected' }}</span>
                                  </div>
                              </div>
                              <div v-if="item.vpn_ovpn" class="vpn-item" title="Download the OpenVPN file">
                                  <img :src="openVpnLogo" alt="OpenVPN" class="vpn-logo cursor-pointer" @click="downloadVpn(item, 'ovpn')"/>
                                  <div class="vpn-item__text">
                                      <span class="vpn-item__name">OpenVPN <button type="button" class="vpn-dl" @click="downloadVpn(item, 'ovpn')"><v-icon icon="mdi-download" size="11"></v-icon>Download</button><button type="button" class="vpn-dl" @click="showVpnQr(item, 'ovpn')"><v-icon icon="mdi-qrcode" size="11"></v-icon>QR</button></span>
                                      <span v-if="item.vpn" class="vpn-state" :class="{ 'is-on': item.vpn.ovpn_connected }"><i></i>{{ item.vpn.ovpn_connected ? 'Connected' : 'Not connected' }}</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </template>
              <!-- <template v-slot:[`item.auto_rotation_time`]="{ item }">
                  {{ item.auto_rotation_time <= 0 ? 'Not defined' : item.auto_rotation_time + ' min' }} </template> -->
                      <!-- Define other custom cell components using similar approach -->
          </v-data-table>
      </div>
      <div v-else-if="selectedView === 'Card'">
          <v-container style="padding:0px">
              <v-row  class="flex gap-5 pb-[30px]">
                  <v-col
                    v-for="(proxy, i) in filteredProxies"
                    :key="proxy.uuid || i"
                    cols="12" sm="auto"
                  >
                      <v-card variant="" class="border" rounded="0" width="400px" max-width="100%" height="100%" >
                          <v-card-item>
                              <div class="flex flex-col gap-y-6">
                                  <div class="flex flex-col text-sm ">
                                    <div class="flex flex-row items-center">
                                        <span class="text-[16px] font-medium">Note:</span>
                                        <v-icon v-if="proxy.note" icon="mdi-square-edit-outline"  class="cursor-pointer my-[1px] mx-4"
                                            data-bs-toggle="modal" color="light-green mx-1"
                                            data-bs-target="#noteModal"
                                            @click="proxyAction(proxy, 'UPDATENOTE')"
                                        ></v-icon>
                                        <v-icon v-else icon="mdi-plus-thick"  class="cursor-pointer my-[1px] mx-4"
                                            data-bs-toggle="modal" color="light-green mx-1"
                                            data-bs-target="#noteModal"
                                            @click="proxyAction(proxy, 'ADDNOTE')"
                                        ></v-icon>
                                    </div>
                                    <div v-if="proxy.note" class="flex justify-between items-center bg-white px-3 py-1 text-black">
                                        <pre  class=" text-green-600 w-full">{{proxy.note}}</pre>
                                    </div>
                                  </div>
                                  <div class="flex flex-row text-sm ">
                                    <span class="text-[16px] font-medium pb-1">Coupon Code:</span>
                                    <div class="pl-4 text-green-600">{{proxy?.coupon_code}}</div>
                                    <v-icon v-if="proxy?.coupon_code" icon="mdi-square-edit-outline"  class="cursor-pointer my-[1px] mx-4"
                                            data-bs-toggle="modal" color="light-green mx-1"
                                            data-bs-target="#couponModal"
                                            @click="proxyAction(proxy, 'EDITCOUPON')"
                                    ></v-icon>
                                    <v-icon v-else icon="mdi-plus-thick"  class="cursor-pointer my-[1px] mx-4"
                                        data-bs-toggle="modal" color="light-green mx-1"
                                        data-bs-target="#couponModal"
                                        @click="proxyAction(proxy, 'EDITCOUPON')"
                                    ></v-icon>
                                  </div>
                                  <div class="flex flex-col text-sm ">
                                    <span class="text-[16px] font-medium pb-1">Server Status:</span>
                                    <div class="flex gap-x-2 justify-between py-1 font-semibold ">
                                      <div class="flex justify-between items-center bg-white px-3 py-1 text-black">
                                          Server Online <v-icon icon="mdi-circle" size="15"
                                              :color="proxy.modem_conn_status ? 'green' : 'red'" class="mr-2"></v-icon>
                                      </div>
                                      <div class="flex justify-between items-center bg-white px-3 py-1 text-black">
                                          Proxy Online <v-icon icon="mdi-circle" size="15"
                                              :color="(proxy.proxy_status === 'CONNECTED' || proxy.proxy_status === 'true' || proxy.proxy_status === true) && proxy.modem_conn_status ? 'green' : 'red'" class="mr-2"></v-icon>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex flex-col text-sm ">
                                    <span class="text-[16px] font-medium pb-1">Port(HTTP/SOCKS5):</span>
                                    <div>
                                      Proxy: {{ proxy.modem_name }}
                                    </div>
                                    <div class="flex items-center justify-between">
                                        {{ proxy.m_type === 'PROPROXYUI' ? 'HTTP / SOCKS5' : 'HTTP' }}: {{ `${proxy.host_domain}:${proxy.http_port}` }}
                                        <div>
                
                                            <v-btn density="compact" variant="text" icon="mdi-pencil-box-multiple-outline"
                                                @click="copyText(`${proxy.host_domain}:${proxy.http_port}${proxy.authentication_user === '' ? '' : ':' + proxy.authentication_user}`)"
                                                color="light-green">
                                                <v-icon icon="mdi-pencil-box-multiple-outline" size="17"></v-icon>
                                            </v-btn>
                                        </div>
                                    </div>
                                    <div v-if="proxy.m_type === 'PROPROXYUI' && proxy.socks_udp" class="pp-udp-note"><span class="udp-pill"><v-icon icon="mdi-check" size="11"></v-icon>UDP</span>SOCKS5 needed for UDP</div>
                                    <div v-if="proxy.m_type !== 'PROPROXYUI'" class="flex items-center justify-between">
                                        <span>SocksV5: {{ `${proxy.host_domain}:${proxy.socket_port}` }}</span>
                                        <div>
                
                                            <v-btn density="compact" variant="text" icon="mdi-pencil-box-multiple-outline"
                                                @click="copyText(`${proxy.host_domain}:${proxy.socket_port}${proxy.authentication_user === '' ? '' : ':' + proxy.authentication_user}`)"
                                                color="light-green">
                                                <v-icon icon="mdi-pencil-box-multiple-outline" size="17"></v-icon>
                                            </v-btn>
                                        </div>
                                    </div>
                                  </div>
                                  <div class="flex flex-row items-center text-sm">
                                    <span class="text-[16px] font-medium pr-3">Auth:</span>
                                    <div class="flex items-center ">
                                      <div class="" @click="alert">
                                          <div class="text-start flex items-center">
                                              <v-icon icon="mdi-account-key" color="light-green mx-1"></v-icon>
                                              {{ (proxy.authentication_user === '' || proxy.authentication_user === null) ? `- - - - - /
                                              - -
                                              - - - ` : proxy.authentication_user }}
                                          </div>
                                          <div class="text-start flex items-center">
                                              <v-icon icon="mdi-ip" color="light-green mx-1"></v-icon>
                                              {{ (proxy.authorization_ips === '' || proxy.authorization_ips === null) ? `- - - - - / - -
                                              - -
                                              - ` : proxy?.authorization_ips?.replace(/,/g, ', ') }}
                                          </div>
                                          <div v-if="proxy.m_type === 'PROPROXYUI'" class="text-start flex items-center pp-edit-auth" data-bs-toggle="modal" data-bs-target="#authenticationModal" @click="proxyAction(proxy, 'AUTHENTICATION')">
                                              <v-icon icon="mdi-application-edit" color="light-green mx-1"></v-icon>Edit User:Pass
                                          </div>
                                      </div>
                                      <div class="flex flex-row pl-4 items-end">
                                          <v-icon v-if="proxy.m_type !== 'PROPROXYUI'" icon="mdi-application-edit"  class="cursor-pointer my-[1px]"
                                          data-bs-toggle="modal" color="light-green mx-1"
                                          data-bs-target="#authenticationModal"
                                          @click="proxyAction(proxy, 'AUTHENTICATION')"
                                          ></v-icon>
                                          <div v-if="proxy.m_type === 'PROXYSMART'" class="w-full flex items-center flex-col justify-center m-[1px]">
                                              <span class=" text-[10px] text-green-500">OpenVPN:</span>
                                                <img src="../../../assets/openVPN.png" :alt="proxy" @click="downloadFile(`${proxy.domain}/get_vpn_profile/${proxy.port_id}.ovpn`)" class=" cursor-pointer"/>
                                          </div>
                                          <div v-else-if="proxy.m_type === 'IPROXY'" class="w-full flex items-center flex-col justify-center m-[1px]">
                                              <span class=" text-[10px] text-green-500">OpenVPN:</span>
                                              <img src="../../../assets/openVPN.png" :alt="proxy" @click="downloadIproxyOpenVpn(proxy)" class=" cursor-pointer"/>
                                          </div>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- ProProxyUI: WireGuard / OpenVPN files, their QR codes and whether they are connected (own row, full width) -->
                                  <div v-if="proxy.m_type === 'PROPROXYUI' && proxy.status === 'ACTIVE' && (proxy.vpn_wg || proxy.vpn_ovpn)" class="flex flex-row items-start text-sm">
                                    <span class="text-[16px] font-medium pr-3">VPN:</span>
                                      <div class="vpn-stack">
                                          <div v-if="proxy.vpn_wg" class="vpn-item" title="Download the WireGuard file">
                                              <img :src="wireGuardLogo" alt="WireGuard" class="vpn-logo vpn-logo--wg cursor-pointer" @click="downloadVpn(proxy, 'wg')"/>
                                              <div class="vpn-item__text">
                                                  <span class="vpn-item__name">WireGuard <button type="button" class="vpn-dl" @click="downloadVpn(proxy, 'wg')"><v-icon icon="mdi-download" size="11"></v-icon>Download</button><button type="button" class="vpn-dl" @click="showVpnQr(proxy, 'wg')"><v-icon icon="mdi-qrcode" size="11"></v-icon>QR</button></span>
                                                  <span v-if="proxy.vpn" class="vpn-state" :class="{ 'is-on': proxy.vpn.wg_connected }"><i></i>{{ proxy.vpn.wg_connected ? 'Connected' : 'Not connected' }}</span>
                                              </div>
                                          </div>
                                          <div v-if="proxy.vpn_ovpn" class="vpn-item" title="Download the OpenVPN file">
                                              <img :src="openVpnLogo" alt="OpenVPN" class="vpn-logo cursor-pointer" @click="downloadVpn(proxy, 'ovpn')"/>
                                              <div class="vpn-item__text">
                                                  <span class="vpn-item__name">OpenVPN <button type="button" class="vpn-dl" @click="downloadVpn(proxy, 'ovpn')"><v-icon icon="mdi-download" size="11"></v-icon>Download</button><button type="button" class="vpn-dl" @click="showVpnQr(proxy, 'ovpn')"><v-icon icon="mdi-qrcode" size="11"></v-icon>QR</button></span>
                                                  <span v-if="proxy.vpn" class="vpn-state" :class="{ 'is-on': proxy.vpn.ovpn_connected }"><i></i>{{ proxy.vpn.ovpn_connected ? 'Connected' : 'Not connected' }}</span>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="flex flex-row items-center justify-between">
                                    <div class="flex flex-row items-center">
                                      <span class="text-[16px] font-medium pr-3">Auto Extend:</span>
                                      <div class="flex ">
                                        <v-switch density="dense" color="light-green" v-model="proxy.auto_extend" label-placement="left"
                                            label="" @click="updateAutoExtend(proxy)"></v-switch>
                                      </div>
                                    </div>
                                    <div>
                                      <span class="text-[16px] font-medium pr-3">Rotation Time:</span>
                                      {{ proxy.auto_rotation_time <= 0 ? 'Not defined' : proxy.auto_rotation_time + ' min' }}
                                    </div>
                                  </div>
                                  <div class="flex flex-col">
                                    <div v-if="calculateRemainingTime(proxy.expired_date).isOne" class="flex flex-row items-center">
                                        <span class="text-[18px] text-red-600 font-extrabold pr-5 min-w-[130px]">Remaining:</span>
                                        <div class="font-extrabold text-[18px] text-red-600">{{ calculateRemainingTime(proxy.expired_date).time }}</div>
                                    </div>
                                    <div v-else class="flex flex-row items-center">
                                        <span class="text-[18px] text-green-600 font-extrabold pr-5 min-w-[130px]">Remaining:</span>
                                        <div class="font-extrabold text-[18px] text-green-600">{{ calculateRemainingTime(proxy.expired_date).time }}</div>
                                    </div>
                                    <div class="flex flex-row items-center">
                                      <span class="text-[16px] font-medium pr-5 min-w-[130px]">Start Time:</span>
                                      <div>{{ formatDate(new Date(proxy.start_date)) }}</div>
                                    </div>
                                    <div class="flex flex-row items-center ">
                                      <span class="text-[16px] font-medium pr-5 min-w-[130px]">Expire Time:</span>
                                      <div>{{ formatDate(new Date(proxy.expired_date)) }}</div>
                                    </div>
                                  </div>
                                  <div class="flex flex-col gap-3">
                                    <div class="flex flex-row items-center">
                                      <span class="text-[16px] font-medium pr-5 min-w-[130px]">IP Status:</span>
                                      <div :class="ipStatus[proxy.uuid] ? 'text-light-green' : 'text-red'"
                                          class="font-bold flex justify-center items-center">
                                          <div>{{ displayProxyIp(proxy) }}</div>
                                          <v-btn density="compact" variant="text" icon="mdi-refresh" color="light-green"
                                              @click="refreshIp(proxy.uuid)"></v-btn>
                                          <v-btn :disabled="!ipStatus[proxy.uuid]" class="font-bold bg-dark text-light ml-3 p-5" variant="outliend"
                                            style="outline:none; font-size: 12px;" density="compact" @click="changeIp(proxy.uuid)">
                                            Change IP
                                        </v-btn>
                                      </div>
                                    </div>
                                    <div class="flex flex-row items-center ">
                                      <span class="text-[16px] font-medium pr-5 min-w-[130px]">Download:</span>
                                      <div v-if="proxy.m_type === 'PROXYSMART'" :style="checkDownloadLimit(proxy, proxy.dl_bytes) ? 'color: red' : ''">
                                        {{ proxy.dl_bytes && proxy.dl_bytes !== "NaN" ? proxy.dl_bytes : '0MB'}} 
                                      </div>
                                      <div v-else-if="proxy.m_type === 'X_PROXY'">
                                          <div :style="checkDownloadLimit(proxy, proxy.dl_bytes) ? 'color: red' : ''">
                                              HTTP: 
                                              {{ proxy.dl_bytes }} MB
                                          </div>
                                          <div :style="checkDownloadLimit(proxy, (proxy.counter_dl_used_bytes/(1024 * 1024))) ? 'color: red' : ''">
                                              SOCKS5:  
                                              {{ (proxy.counter_dl_used_bytes / (1024 * 1024)).toFixed(2) }} MB
                                          </div>
                                      </div>
                                      <div v-else-if="proxy.m_type === 'IPROXY'">
                                          <div>
                                              {{ proxy.dl_bytes && proxy.dl_bytes !== "NaN" ? (parseFloat(proxy.dl_bytes).toFixed(2) + ' MB') : '0MB'}} 
                                          </div>
                                      </div>
                                      <div v-else-if="proxy.m_type === 'PROPROXYUI'" :style="ppOver(proxy) ? 'color: red' : ''">
                                          {{ ppUsage(proxy) }}
                                      </div>
                                    </div>
                                    <!-- ProProxyUI: the OS profile and MTU in use -->
                                    <div v-if="proxy.m_type === 'PROPROXYUI' && proxy.os_spoofing && ppOsActive(proxy)" class="flex flex-row items-center">
                                      <span class="text-[16px] font-medium pr-5 min-w-[130px]">OS Spoofing:</span>
                                      <span class="os-chip"><v-icon icon="mdi-cellphone-link" size="14"></v-icon>{{ ppOsChip(proxy) }}</span>
                                    </div>
                                  </div>

                              </div>
                          </v-card-item>

                          <v-card-actions>
                            <v-list class="flex gap-1 flex-wrap px-0 py-0  z-0 w-full customlist"
                            style="border-top-left-radius: 0px;border-top-right-radius: 0px">

                              <template v-for="(button, index) in getActionButtons(proxy)" :key="index">
                                  <!-- Check if button is "abc" -->

                                  <v-btn @click="proxyAction(proxy, button)" rounded="1"
                                      class="bg-dark text-light text-center ms-0 "
                                      style="font-size: 10px; width: 120px; outline: none; border-bottom: 1px solid #345;"
                                      type="button"
                                      :data-bs-toggle="(button === 'AUTO ROTATION' || button === 'AUTHENTICATION' || button === 'EXTEND' || button === 'OS Spoofing' || button === 'MOVE LOCATION' || button === 'VPN' || button === 'IP HISTORY') && 'modal'"
                                      :data-bs-target="button === 'AUTO ROTATION' ? '#autoRotationDialog' :
                                        button === 'AUTHENTICATION' ? '#authenticationModal' :
                                            button === 'EXTEND' ? '#extendLicenseModal' : button === 'OS Spoofing' ? '#osSpoofingModal' :
                                              button === 'MOVE LOCATION' ? '#moveLocationModal' : button === 'VPN' ? '#vpnModal' : button === 'IP HISTORY' ? '#ipChangeHistoryModal' :
                                                ''">
                                      {{ buttonLabel(button, proxy) }}
                                  </v-btn>
                                  
                              </template>
                            </v-list>
                          </v-card-actions>
                      </v-card>
                  </v-col>
              </v-row>
          </v-container>
      </div>

  </data>
  <div>
      <AutoRotationDialog :uuid="currentItem ? currentItem.uuid : null"
          :min_time_change_ip="currentItem ? currentItem.min_time_change_ip : null" :rotation_time="currentItem?.auto_rotation_time" @close="updatedHandler" />
      <AuthenticateDialog :license="currentItem ? currentItem : null" @close="updatedHandler" />
      <ExtendLicenseDialog :license="currentItem ? currentItem : null" @close="updatedHandler" />
      <OSSpoofingDialog :license="currentItem ? currentItem : null" @close="updatedHandler" />
      <MoveLocationDialog :license="currentItem ? currentItem : null" @close="updatedHandler" />
      <VpnDialog :license="currentItem ? currentItem : null" />
      <IPChangeHistoryDialog :license="currentItem ? currentItem : null" />
      <!-- ProProxyUI: the WireGuard / OpenVPN QR code from the VPN row's QR button -->
      <v-dialog :model-value="!!vpnQrPop" max-width="300" @update:model-value="(v) => { if (!v) vpnQrPop = null }">
        <div v-if="vpnQrPop" class="vpn-qr-pop">
          <b>{{ vpnQrPop.title }}</b>
          <img v-if="vpnQrPop.img" :src="vpnQrPop.img" alt="QR code" class="vpn-qr-pop__img"/>
          <div v-else class="vpn-qr-pop__img vpn-qr-pop__wait">Making the QR code…</div>
          <div class="text-sm text-center">{{ vpnQrPop.text }}</div>
          <div class="text-xs text-center vpn-qr-pop__sub">{{ vpnQrPop.sub }}</div>
          <button type="button" class="vpn-dl" style="padding: 2px 14px;" @click="vpnQrPop = null">Close</button>
        </div>
      </v-dialog>
      <NoteDialog :license="currentItem ? currentItem : null" @close="updatedHandler" />
      <CouponDialog :license="currentItem ? currentItem : null" @close="updatedHandler" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { matchesProxySearch } from '@/utils/proxy-search';
import AutoRotationDialog from "@/components/Customer/MyProxy/Modals/AutoRotationModal.vue"
import AuthenticateDialog from "@/components/Customer/MyProxy/Modals/AuthenticationModal.vue"
import NoteDialog from "@/components/Customer/MyProxy/Modals/NoteModal.vue"
import CouponDialog from "@/components/Customer/MyProxy/Modals/CouponModal.vue"
import ExtendLicenseDialog from "@/components/Customer/MyProxy/Modals/ExtendLicenseModal.vue"
import OSSpoofingDialog from "@/components/Customer/MyProxy/Modals/OSSpoofingModal.vue"
import MoveLocationDialog from "@/components/Customer/MyProxy/Modals/MoveLocationModal.vue"
import VpnDialog from "@/components/Customer/MyProxy/Modals/VpnModal.vue"
import IPChangeHistoryDialog from "@/components/Customer/MyProxy/Modals/IPChangeHistoryModal.vue"
import wireGuardLogo from "@/assets/wireguard.svg"
import openVpnLogo from "@/assets/openVPN.png"
import { wgQr, ovpnQr } from "@/helpers/vpnQr"
import { useAccountStore, useAlertStore, useProxyStore } from "@/stores"
import copy from "clipboard-copy"
// import CheckboxYes from "@/assets/check_yes_x.png"
// import CheckboxNo from "@/assets/check_no_x.png"
import { storeToRefs } from 'pinia';
import { watchEffect } from 'vue';
// import { connectToWebSocket } from "@/stores/socket.store"
import { fetchWrapper } from '@/helpers';


const selectedItems = ref([]);
const currentItem = ref(null)
const licenseStatusList = ref(['Active', 'Expired'])
const viewList = ref(['Card', 'Table']);
const expiringIn = ref(false);

const ipStatus = ref({})

const isIpv6Proxy = (proxy) => Boolean(proxy?.is_ipv6 || proxy?.modem_is_ipv6)

const displayProxyIp = (proxy) =>
  proxy?.public_ip || (isIpv6Proxy(proxy) ? '* : * : * : *' : '* . * . * . * ')

const offsetHeight = 300; // Adjust this value as needed

const computedHeight = ref(window.innerHeight - offsetHeight);

const handleResize = () => {
computedHeight.value = window.innerHeight - offsetHeight;
};
const baseUrl = `${process.env.VUE_APP_VUE_API_URL}`;
const downloadFile = async (fileUrl) => {
    const backendUrl = `${baseUrl}/account/download?url=${encodeURIComponent(fileUrl)}`;

    try {
    // Call the backend proxy with the dynamic URL as a query parameter

    const response = await fetch(backendUrl, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    // Get the file as a blob
    const blob = await response.blob();

    // Create a URL for the blob
    const blobUrl = window.URL.createObjectURL(blob);

    // Create a temporary <a> element to trigger the download
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', 'vpn_profile.ovpn'); // Set the file name

    // Append the link to the body and trigger the click
    document.body.appendChild(link);
    link.click();

    // Clean up and remove the link
    document.body.removeChild(link);

    // Revoke the object URL to release memory
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Error downloading the file:', error);
  }
};

const downloadIproxyOpenVpn = async (item) => {
    try {
        const url = `${baseUrl}/openvpn/?uuid=${item.uuid}`;
        const response = await fetch(url, { method: 'GET' });
        if (!response.ok) throw new Error('Failed to get OpenVPN config');
        const blob = await response.blob();
        const disposition = response.headers.get('Content-Disposition');
        let filename = (item.public_ip || 'config').replace(/[^a-zA-Z0-9.-]/g, '_') + '.ovpn';
        if (disposition) {
            const match = disposition.match(/filename="?([^";\n]+)"?/);
            if (match) filename = match[1].trim();
        }
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        console.error('Error downloading OpenVPN config:', error);
        useAlertStore().error('Failed to download OpenVPN config');
    }
};

const checkDownloadLimit = (item, value) => {
    if(item.m_type==='X_PROXY') {
        if(parseFloat(item.counter_dl_limit_quota) !== 0 && item.counter_dl_limit_by?.toUpperCase() === 'DAILY' && parseFloat(item.counter_dl_limit_quota) <= parseFloat(value)) {
            return true
        }
        else return false
    } else {
        if(item.quota_dir === 'in' && item.quota_type === "daily") {
            if (value === 0 || value === '0' || value === null || value === undefined || value === '') {
                return false
            }
            const regex = /(\d+(\.\d+)?)\s*(\w+)/;
            const matches = String(value).match(regex);
            if (!matches) return false
            if(matches[3]?.toUpperCase() === 'MB' && parseFloat(matches[1]) >= parseFloat(item.band_amount)) return true
            else if(matches[3]?.toUpperCase() === 'GB' && (parseFloat(matches[1]) * 1024) >= parseFloat(item.band_amount)) return true
            else return false

        } else return false
    }
}

onMounted(() => {
window.addEventListener('resize', handleResize);
});

onBeforeUnmount(() => {
window.removeEventListener('resize', handleResize);
});

const toggleSelection = () => {
    expiringIn.value = !expiringIn.value
};
const proxyStore = useProxyStore()
const proxyAction = (item, button) => {
  currentItem.value = item
  switch (button) {
      case "STATUS API":
          window.open(`${process.env.VUE_APP_VUE_API_URL}/proxy/status?license=` + item.uuid)
          break
      case "CHANGE IP (URL)":
          copyText(`${process.env.VUE_APP_VUE_CUSTOM_API_URL}/proxy/change-ip?license=` + item.uuid)
          break
      case "REBOOT (URL)":
          copyText(`${process.env.VUE_APP_VUE_CUSTOM_API_URL}/proxy/reboot-device?license=` + item.uuid)
          break
      case "AUTO ROTATION":
          // autoRotationDialog.value = true
          // alert()
          break
      case "REBOOT DEVICE":
          proxyStore.rebootDevice(item.uuid)
          break;
      case "AUTHENTICATION":
          break
      case "UPDATENOTE":
          break
      case "ADDNOTE":
          break
      case "EDITCOUPON":
          break
      case "EXTEND":
          // proxyStore.extendLicense(item.uuid)
          break
      case "OS Spoofing":
        break
      case "MOVE LOCATION":
        break
      case "VPN":
        break
      case "IP HISTORY":
        break
      case "COPY INFO":
        copyProxyInfo(item)
        break
      case "GENERATE NEW URL":
        proxyStore.updateLicense(item.uuid)
  }
}
const actionButtons = ref(
  ["CHANGE IP (URL)", "GENERATE NEW URL", "STATUS API", "AUTO ROTATION", "REBOOT DEVICE", "EXTEND", "COPY INFO"]
)
const actionButtonsIProxy = ref(
  ["CHANGE IP (URL)", "REBOOT (URL)", "GENERATE NEW URL", "STATUS API", "AUTO ROTATION", "REBOOT DEVICE", "EXTEND", "OS Spoofing", "COPY INFO"]
)
const actionButtonsSmart = ref(
    ["CHANGE IP (URL)", "GENERATE NEW URL", "STATUS API", "AUTO ROTATION", "REBOOT DEVICE", "EXTEND", "OS Spoofing", "COPY INFO", "MOVE LOCATION"]
)

// ProProxyUI: no MOVE LOCATION (ProxySmart only); OS Spoofing and VPN only when the server offers them
const ppButtons = (proxy) => [
  "CHANGE IP (URL)", "GENERATE NEW URL", "STATUS API", "AUTO ROTATION", "REBOOT DEVICE", "EXTEND",
  ...(proxy?.os_spoofing ? ["OS Spoofing"] : []),
  ...(proxy?.vpn_supported && proxy?.status === 'ACTIVE' ? ["VPN"] : []),
  "IP HISTORY",
  "COPY INFO",
]
// ProProxyUI button labels (the keys and modal targets stay the same)
const buttonLabel = (button, proxy) => {
  if (proxy?.m_type !== 'PROPROXYUI') return button
  if (button === 'OS Spoofing') return 'TCP/IP OS + MTU'
  if (button === 'VPN') return 'VPN + QR CODE'
  return button
}
// ProProxyUI OS spoofing chip: a profile or a manual MTU is set
const ppOsActive = (p) => !!(p?.os_label || Number(p?.mtu))
const ppOsChip = (p) => `Active · ${p?.os_label || 'Native'}${Number(p?.mtu) ? ' · MTU ' + p.mtu : ''}`

const getActionButtons = (proxy) => {
  if (proxy?.m_type === 'PROPROXYUI') return ppButtons(proxy)
  const buttons = proxy?.m_type === 'IPROXY'
    ? actionButtonsIProxy.value
    : (proxy?.m_type === 'X_PROXY' ? actionButtons.value : actionButtonsSmart.value)
  return isIpv6Proxy(proxy) ? buttons.filter(button => button !== 'OS Spoofing') : buttons
}

// ProProxyUI: today's data (dl_bytes = MB used today) against the port's daily allowance (daily_gb, 0 = none)
const ppUsage = (p) => `Today: ${(Number(p?.dl_bytes) || 0).toFixed(2)} MB${Number(p?.daily_gb) > 0 ? ` of ${p.daily_gb} GB` : ''}`
const ppOver = (p) => Number(p?.daily_gb) > 0 && Number(p?.dl_bytes) >= Number(p.daily_gb) * 1024
// ProProxyUI: the WireGuard / OpenVPN logo downloads that file
const downloadVpn = async (proxy, type) => {
  if (type === 'ovpn' && !/^[^:\s]+:[^\s]+$/.test(String(proxy?.authentication_user || ''))) {
    useAlertStore().error('OpenVPN logs in with a username and password. Set a username:password login under Authentication first.')
    return
  }
  const f = await proxyStore.vpnFile(proxy.uuid, type)
  if (!f || !f.content) return
  const a = document.createElement('a')
  a.href = URL.createObjectURL(new Blob([f.content], { type: 'application/octet-stream' }))
  a.download = f.filename
  a.click()
  setTimeout(() => URL.revokeObjectURL(a.href), 5000)
}
// ProProxyUI: the QR button next to Download (WireGuard: the profile; OpenVPN: a 10-minute download link)
const vpnQrPop = ref(null)
const showVpnQr = async (proxy, type) => {
  if (type === 'ovpn' && !/^[^:\s]+:[^\s]+$/.test(String(proxy?.authentication_user || ''))) {
    useAlertStore().error('OpenVPN logs in with a username and password. Set a username:password login under Authentication first.')
    return
  }
  const port = proxy?.http_port
  vpnQrPop.value = type === 'wg'
    ? { title: `WireGuard · ${port}`, img: null, text: 'In the WireGuard app: tap +, then "Scan from QR code".', sub: 'No login needed: the keys are in the code.' }
    : { title: `OpenVPN · ${port}`, img: null, text: 'Scan with the phone camera. The profile downloads: open it with OpenVPN Connect.', sub: 'The link works for 10 minutes. Log in with your proxy username and password.' }
  const img = type === 'wg' ? await wgQr(proxy.uuid) : await ovpnQr(proxy.uuid)
  if (!img) { vpnQrPop.value = null; return }
  if (vpnQrPop.value) vpnQrPop.value = { ...vpnQrPop.value, img }
}
// ProProxyUI: whether each WireGuard / OpenVPN is connected, re-read every 30 s while this page is open and visible
let vpnLiveTimer = null
const refreshVpnLive = () => { if (document.visibilityState === 'visible') proxyStore.refreshVpnLive() }
onMounted(() => { vpnLiveTimer = setInterval(refreshVpnLive, 30000) })
onBeforeUnmount(() => { clearInterval(vpnLiveTimer) })

const copyText = (text) => {
  copy(text)
  const alertStore = useAlertStore()
  alertStore.success("Copied");
}

const copyProxyInfo = (item) => {
  const auth = item.authentication_user ? `:${item.authentication_user}` : ''
  const httpLine = `HTTP: ${item.host_domain}:${item.http_port}${auth}`
  const socksLine = `SOCKS5: ${item.host_domain}:${item.socket_port}${auth}`
  const rotationUrl = (item.m_type === 'PROXYSMART' && item.proxysmart_rotation_link)
    ? item.proxysmart_rotation_link
    : item.rotation_link
  const rotationLine = rotationUrl ? `IP rotation URL: ${rotationUrl}` : ''
  const text = [httpLine, socksLine, rotationLine].filter(Boolean).join('\n')
  copy(text)
  const alertStore = useAlertStore()
  alertStore.success("Proxy info copied")
}

const accountStore = useAccountStore();
const { user } = storeToRefs(accountStore);

const headers = ref(
  [
      { title: 'No', align: 'center', key: 'no' },
      { title: 'Note', align: 'left', key: 'note'},
      { title: 'Coupon Code', align: 'center', key: 'coupon_code' },
      { title: 'Status', align: 'center', key: 'status' },
      { title: 'Port (HTTP / SOCKS5)', align: 'center', key: 'proxy_ports', minWidth: "300", width: "300" },
      { title: 'Auth', align: 'center', key: 'auth', minWidth: "250", width: "250" },
      { title: 'Auto Extend / Rotation Time', align: 'center', key: 'auto_extend', minWidth: "150", width: "150" },  
      // { title: 'Remaining', align: 'center', key: 'date', minWidth: "200", width: "200" },
      { title: 'Start/Expire Time', align: 'center', key: 'expired_date', minWidth: "200", width: "200" },
      { title: 'IP Status / Download', align: 'center', key: 'ip_status' },
      // { title: 'OpenVPN Connection File', align: 'center', key: 'openVPN'},
      // { title: 'Auto Rotation Time', align: 'center', key: 'auto_rotation_time' },
      { title: 'Actions', align: 'center', key: 'buttonBar' },
  ]
);

const { proxyList, loading } = storeToRefs(proxyStore)
const numberedproxies = ref([])

const selectedLicenseStatus = ref("")
const selectedView = ref("")
const searchProxy = ref("")
const filteredProxies = computed(() => numberedproxies.value.filter(item =>
  item.status.toUpperCase() === selectedLicenseStatus.value.toUpperCase()
  && (!expiringIn.value || calculateRemainingTime(item.expired_date).isOne)
  && matchesProxySearch(item, searchProxy.value)
))
watchEffect(() => {
  if (user && user.value && user.value.user_name) {
      proxyStore.getProxyList()
    //   connectToWebSocket(user.value.user_name)
  }
}, [])
watchEffect(() => {

  numberedproxies.value = proxyList.value.map((item, index) => {
      if (ipStatus.value[item.uuid] === undefined)
          ipStatus.value = { ...ipStatus.value, [item.uuid]: true }
      return { ...item, no: index + 1, buttonBar: index }; // Add 'no' field with 1-based numbering
  })
}, [proxyList.value])
watchEffect(() => {
  selectedLicenseStatus.value = licenseStatusList.value[0]
  selectedView.value = viewList.value[0]
}, [licenseStatusList.value])
const changeIp = (uuid) => {
  ipStatus.value = {
      ...ipStatus.value,
      [uuid]: false
  }
  proxyStore.changeIp(uuid).then(res => {
      proxyStore.getProxyList()
      ipStatus.value = {
          ...ipStatus.value,
          [uuid]: true
      }
      setTimeout(() => {
          refreshIp(uuid);
      }, 2000);
      refreshIp(uuid);
  })
}

const refreshIp = (uuid) => {
  proxyStore.refreshIp(uuid).then(res => {
      if (res) {
          numberedproxies.value = numberedproxies.value.map(proxy => {
              if (proxy && proxy.uuid === uuid) {
                  proxy.public_ip = res
              }
              return proxy

          })
      }

  })
}

const updatedHandler = () => {
  proxyStore.getProxyList()
}
const updateAutoExtend = (item) => {
  let targetFlag = !item.auto_extend
  proxyStore.updateAutoExtend(item.uuid, targetFlag).then(res => {
      if (res === false)
          proxyStore.getProxyList()
  })
}
const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year}  ${hours}:${minutes}:${seconds}`;
}
const calculateRemainingTime = (expiringTime) => {
    const now = new Date();
    const expirationDate = new Date(expiringTime);
    const timeDifference = expirationDate.getTime() - now.getTime();
    if(timeDifference<0){
        return "Expired"
    }
    // Convert milliseconds to days, hours, minutes, and seconds
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const str = (days ? `${days} Days, ` : '') +
        (hours ? `${hours} Hours, ` : '') +
        (minutes>=0 ? `${minutes} Mins ` : '')
    return { time: str, isOne: days ? false : true }
}

</script>
<style>
::-webkit-scrollbar {
  background: #78ffe7;
}
/* ProProxyUI: VPN files (download / QR / connected), QR pop-up, OS spoofing chip, UDP pill */
.vpn-stack { display: flex; flex-direction: column; gap: 6px; margin: 1px 0; }
.pp-edit-auth { cursor: pointer; color: #22c55e; font-size: 13px; }
.pp-udp-note { display: flex; align-items: center; gap: 6px; font-size: 12px; color: #6b7280; margin: 1px 0 3px; }
body.dark .pp-udp-note { color: #bcbbc7; }
.vpn-item { display: flex; align-items: center; gap: 6px; }
.vpn-item__text { display: flex; flex-direction: column; line-height: 1.25; }
.vpn-item__name { display: inline-flex; align-items: center; gap: 5px; font-size: 11px; color: #16a34a; white-space: nowrap; }
.vpn-logo { width: 26px; height: 26px; object-fit: contain; }
.vpn-logo--wg { background: #ffffff; border-radius: 50%; padding: 2px; }
.vpn-dl { display: inline-flex; align-items: center; gap: 2px; padding: 0 6px; border: 1px solid #22c55e; border-radius: 6px; font-size: 10.5px; line-height: 16px; color: #16a34a; background: transparent; cursor: pointer; }
.vpn-dl:hover { background: rgba(34, 197, 94, 0.12); }
.vpn-state { display: inline-flex; align-items: center; gap: 4px; font-size: 10px; white-space: nowrap; color: #ef4444; }
.vpn-state i { display: inline-block; width: 7px; height: 7px; border-radius: 50%; background: #ef4444; }
.vpn-state.is-on { color: #16a34a; }
.vpn-state.is-on i { background: #22c55e; }
.vpn-qr-pop { display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 16px; border-radius: 12px; background: #ffffff; color: #000000; border: 1px solid #dee2e6; }
.vpn-qr-pop__img { width: 210px; height: 210px; background: #ffffff; border-radius: 8px; padding: 6px; }
.vpn-qr-pop__wait { display: flex; align-items: center; justify-content: center; color: #555; font-size: 12px; }
.vpn-qr-pop__sub { color: #6b7280; }
.os-chip { display: inline-flex; align-items: center; gap: 5px; padding: 2px 9px; border-radius: 6px; background: #dcfce7; color: #166534; font-size: 13px; font-weight: 600; }
.udp-pill { display: inline-flex; align-items: center; gap: 2px; margin-left: 6px; padding: 0 7px; border-radius: 999px; font-size: 10.5px; line-height: 16px; vertical-align: 1px;
  color: #16a34a; background: rgba(34, 197, 94, 0.15); border: 1px solid rgba(34, 197, 94, 0.45); cursor: help; }
body.dark .vpn-item__name, body.dark .vpn-dl, body.dark .vpn-state.is-on, body.dark .udp-pill { color: #4ade80; }
body.dark .vpn-qr-pop { background: #34334a; color: #ffffff; border-color: #45445e; }
body.dark .vpn-qr-pop__sub { color: #bcbbc7; }
body.dark .os-chip { background: rgba(34, 197, 94, 0.18); color: #86efac; }
</style>
